import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Drawer from "../../../components_v2/Drawer/Drawer";
import { Button, Row } from "react-bootstrap";
import { axios } from "api";

const FooterWrapper = styled.div`
  position: fixed;
  width: calc(100% - 48px);
  margin-bottom: 25px;
  margin-top: 25px;
`;

const PlayListName = styled.input`
  color: #000;
  font-family: "Proxima-Nova";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  padding: 12px 16px;
  border: 1px solid #a3a3a3;
  width: 100%;
  margin-top: 24px;
`;

const PlayListDesc = styled.textarea`
  color: #000;
  font-family: "Proxima-Nova";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.352px;
  padding: 12px 16px;
  border: 1px solid #a3a3a3;
  width: 100%;
  margin-top: 24px;
  resize: none;
  height: 110px;
`;

const SavePlaylistButton = styled(Button)({
  fontSize: ["18px"],
  fontFamily: "Proxima-nova",
  textTransform: "uppercase",
  color: (props) => (props.disabled ? "#4c4c4c" : "#fff"),
  background: (props) => (props.disabled ? "#ebebeb" : "#000"),
  fontStyle: "normal",
  fontWeight: "700",
  lineHeight: "24px",
  letterSpacing: "0.9px",
  padding: "12px 32px",
  width: "100%",
});

const EditPlayList = ({ isOpen, onClose, title, uuid, description, onSuccess }) => {
  const [playListTitle, setPlayListTitle] = useState(
    `New Playlist ${new Date().toLocaleDateString("en-GB")}`,
  );

  const [playListDesc, setPlayListDesc] = useState("");

  useEffect(() => {
    setPlayListTitle(() => title);
  }, [title]);

  useEffect(() => {
    setPlayListDesc(() => description);
  }, [description]);

  const handleTitleChange = (e) => {
    setPlayListTitle(e.target.value);
  };

  const handleDescChange = (e) => {
    setPlayListDesc(e.target.value);
  };

  const createPlayList = async () => {
    try {
      const res = await axios.put(`playlists/${uuid}`, {
        title: playListTitle,
        description: playListDesc,
      });

      if (res.status === 200) {
        onSuccess && onSuccess();
        closeDrawer();
      }
    } catch (e) {
      console.error(e);
    }
  };

  const closeDrawer = () => {
    onClose();
  };

  return (
    <Drawer
      isOpen={isOpen}
      title="Edit Playlist"
      onClose={() => {
        closeDrawer();
      }}
    >
      <div>
        <div className="createPlayListWrapper">
          <PlayListName
            type="text"
            value={playListTitle}
            onChange={handleTitleChange}
          />
          <PlayListDesc
            placeholder="Description (Max 500 Characters)"
            onChange={handleDescChange}
            value={playListDesc}
          ></PlayListDesc>
        </div>
        <FooterWrapper>
          <SavePlaylistButton onClick={createPlayList}>Save</SavePlaylistButton>
        </FooterWrapper>
      </div>
    </Drawer>
  );
};
export default EditPlayList;
